import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';

import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
var render = function render() {
  var _vm$required$filters$, _vm$required$filters$2, _vm$taken$filters$ord, _vm$taken$filters$tar, _vm$taken$filters$win;
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [!_vm.hasAccessToPage ? _c("Error", {
    attrs: {
      error: {
        title: "Access not granted",
        description: "You are not allowed to access to this functionality.",
        link: "userHome",
        linkTitle: "home"
      }
    }
  }) : _c("section", {
    staticClass: "content-centered large text-left"
  }, [_c("div", {
    staticClass: "container-centered"
  }, [_c(VTabs, {
    attrs: {
      centered: ""
    },
    model: {
      value: _vm.tab,
      callback: function callback($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c(VTab, {
    key: 1
  }, [_vm._v("Photos required")]), _c(VTab, {
    key: 2
  }, [_vm._v("Photos taken")])], 1), _c(VTabsItems, {
    model: {
      value: _vm.tab,
      callback: function callback($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c(VTabItem, {
    key: 1
  }, [_c("div", [_c("div", {
    staticClass: "mt-default"
  }, [_c("div", {
    staticClass: "container-centered small"
  }, [_c("div", {
    staticClass: "list-live-search-container"
  }, [_c("div", {
    staticClass: "list-live-search-container-row x3"
  }, [_c(VAutocomplete, {
    attrs: {
      disabled: ((_vm$required$filters$ = _vm.required.filters.users) === null || _vm$required$filters$ === void 0 ? void 0 : _vm$required$filters$.length) <= 0,
      items: _vm.required.filters.users,
      "item-value": "id",
      "item-text": "name",
      label: !_vm.required.isFiltersPending ? "Users" : "Loading...",
      "hide-details": "auto",
      multiple: "",
      clearable: ""
    },
    on: {
      blur: function blur($event) {
        _vm.required.formSearch.userIds != _vm.required.lastSearch.userIds && _vm.requiredSearch();
      }
    },
    model: {
      value: _vm.required.formSearch.userIds,
      callback: function callback($$v) {
        _vm.$set(_vm.required.formSearch, "userIds", $$v);
      },
      expression: "required.formSearch.userIds"
    }
  }), _c(VAutocomplete, {
    attrs: {
      disabled: ((_vm$required$filters$2 = _vm.required.filters.wines) === null || _vm$required$filters$2 === void 0 ? void 0 : _vm$required$filters$2.length) <= 0,
      items: _vm.required.filters.wines,
      "item-value": "id",
      "item-text": "name",
      label: !_vm.required.isFiltersPending ? "Wines" : "Loading...",
      "hide-details": "auto",
      multiple: "",
      clearable: ""
    },
    on: {
      blur: function blur($event) {
        _vm.required.formSearch.wineIds != _vm.required.lastSearch.wineIds && _vm.requiredSearch();
      }
    },
    model: {
      value: _vm.required.formSearch.wineIds,
      callback: function callback($$v) {
        _vm.$set(_vm.required.formSearch, "wineIds", $$v);
      },
      expression: "required.formSearch.wineIds"
    }
  }), _c(VAutocomplete, {
    attrs: {
      items: _vm.required.filters.allowedStatus,
      "item-value": "id",
      "item-text": "name",
      label: "Status",
      "hide-details": "auto",
      multiple: "",
      clearable: ""
    },
    on: {
      blur: function blur($event) {
        _vm.required.formSearch.allowedStatus != _vm.required.lastSearch.allowedStatus && _vm.requiredSearch();
      }
    },
    model: {
      value: _vm.required.formSearch.allowedStatus,
      callback: function callback($$v) {
        _vm.$set(_vm.required.formSearch, "allowedStatus", $$v);
      },
      expression: "required.formSearch.allowedStatus"
    }
  })], 1)])]), _c("div", {
    staticClass: "mt-default"
  }, [_c("div", {
    staticClass: "container-centered"
  }, [_vm.required.isSearchPending ? _c("div", {
    staticClass: "list-empty text-center text-italic"
  }, [_c("p", [_vm._v("Loading data ...")])]) : _vm.required.results.totalCount === null ? _c("div", {
    staticClass: "list-empty text-center text-italic"
  }, [_vm._v(" Please do a search to display the results table ")]) : _vm.required.results.totalCount === 0 ? _c("div", {
    staticClass: "list-empty text-center text-italic"
  }, [_vm._v(" No required photo matchs these filters ")]) : _c(VDataTable, {
    staticClass: "cursor--pointer",
    attrs: {
      headers: _vm.required.results.headers,
      items: _vm.required.results.items,
      "items-per-page": +_vm.required.results.totalCount,
      "footer-props": {
        options: {
          itemsPerPage: -1
        }
      }
    },
    on: {
      "click:row": _vm.requiredRowClick
    },
    scopedSlots: _vm._u([{
      key: "item.wine",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(item.wine.displayName + " - " + item.wine.namingData.sku) + " ")];
      }
    }, {
      key: "item.nbBottlesRemaining",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c("svg", {
          staticClass: "icon icon-xxs dot mr-1",
          class: [_vm.requiredGetStatusClass(item)],
          attrs: {
            xmlns: "http://www.w3.org/2000/svg",
            width: "512",
            height: "512",
            viewBox: "0 0 512 512"
          }
        }, [_c("circle", {
          attrs: {
            cx: "256",
            cy: "256",
            r: "256"
          }
        })]), _vm._v(" " + _vm._s(item.nbBottlesRemaining) + " ")];
      }
    }, {
      key: "item.deliveredDate",
      fn: function fn(_ref3) {
        var _item$order;
        var item = _ref3.item;
        return [_vm._v(" " + _vm._s(_vm._f("formatDate_string")((_item$order = item.order) === null || _item$order === void 0 ? void 0 : _item$order.deliveredDate)) + " ")];
      }
    }, {
      key: "item.actions",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_c("div", {
          staticClass: "td-without-link --inline-actions",
          on: {
            click: function click($event) {
              $event.stopPropagation();
            }
          }
        }, [_c("div", {
          staticClass: "table-actions"
        }, [item.status === _vm.TASTING_PHOTOS.REQUIRED.STATUS.CANCELLED.id ? _c("div", {
          staticClass: "text-italic"
        }, [_vm._v(" CANCELLED ")]) : [_c("a", {
          attrs: {
            href: "#",
            disabled: item.isBusy
          },
          on: {
            click: function click($event) {
              return _vm.openUpload(item);
            }
          }
        }, [_vm._v(" Upload photo ")]), _c("a", {
          attrs: {
            href: "#",
            disabled: item.isBusy
          },
          on: {
            click: function click($event) {
              return _vm.requiredRowClick(item);
            }
          }
        }, [_vm._v(" Edit number ")]), _c("a", {
          attrs: {
            href: "#",
            disabled: item.isBusy
          },
          on: {
            click: function click($event) {
              return _vm.requiredConfirmCancel(item);
            }
          }
        }, [_vm._v(" Cancel ")])]], 2)])];
      }
    }], null, true)
  })], 1)])])]), _c("TastingPhotoRequiredFormModal", {
    ref: "tastingPhotoRequiredForm",
    attrs: {
      id: _vm.required.editedId
    },
    on: {
      entityUpdated: _vm.requiredSearch
    }
  })], 1), _c(VTabItem, {
    key: 2
  }, [_c("div", [_c("div", {
    staticClass: "mt-default"
  }, [_c("div", {
    staticClass: "container-centered small"
  }, [_c("div", {
    staticClass: "flex justify-end"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click($event) {
        return _vm.openUpload();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-plus mr-1",
    attrs: {
      size: "0.85rem"
    }
  }), _vm._v(" Add new photo ")], 1)], 1), _c("div", {
    staticClass: "list-live-search-container"
  }, [_c("div", {
    staticClass: "list-live-search-container-row x2"
  }, [_c(VAutocomplete, {
    attrs: {
      disabled: ((_vm$taken$filters$ord = _vm.taken.filters.orders) === null || _vm$taken$filters$ord === void 0 ? void 0 : _vm$taken$filters$ord.length) <= 0,
      items: _vm.taken.filters.orders,
      "item-value": "id",
      "item-text": "name",
      label: !_vm.taken.isFiltersPending ? "Orders" : "Loading...",
      "hide-details": "auto",
      multiple: "",
      clearable: ""
    },
    on: {
      blur: function blur($event) {
        _vm.taken.formSearch.orderIds != _vm.taken.lastSearch.orderIds && _vm.takenSearch();
      }
    },
    model: {
      value: _vm.taken.formSearch.orderIds,
      callback: function callback($$v) {
        _vm.$set(_vm.taken.formSearch, "orderIds", $$v);
      },
      expression: "taken.formSearch.orderIds"
    }
  })], 1), _c("div", {
    staticClass: "list-live-search-container-row x3"
  }, [_c(VAutocomplete, {
    attrs: {
      disabled: ((_vm$taken$filters$tar = _vm.taken.filters.targetedUsers) === null || _vm$taken$filters$tar === void 0 ? void 0 : _vm$taken$filters$tar.length) <= 0,
      items: _vm.taken.filters.targetedUsers,
      "item-value": "id",
      "item-text": "name",
      label: !_vm.taken.isFiltersPending ? "Users" : "Loading...",
      "hide-details": "auto",
      multiple: "",
      clearable: ""
    },
    on: {
      blur: function blur($event) {
        _vm.taken.formSearch.targetedUserIds != _vm.taken.lastSearch.targetedUserIds && _vm.takenSearch();
      }
    },
    model: {
      value: _vm.taken.formSearch.targetedUserIds,
      callback: function callback($$v) {
        _vm.$set(_vm.taken.formSearch, "targetedUserIds", $$v);
      },
      expression: "taken.formSearch.targetedUserIds"
    }
  }), _c(VAutocomplete, {
    attrs: {
      disabled: ((_vm$taken$filters$win = _vm.taken.filters.wines) === null || _vm$taken$filters$win === void 0 ? void 0 : _vm$taken$filters$win.length) <= 0,
      items: _vm.taken.filters.wines,
      "item-value": "id",
      "item-text": "name",
      label: !_vm.required.isFiltersPending ? "Wines" : "Loading...",
      "hide-details": "auto",
      multiple: "",
      clearable: ""
    },
    on: {
      blur: function blur($event) {
        _vm.taken.formSearch.wineIds != _vm.taken.lastSearch.wineIds && _vm.takenSearch();
      }
    },
    model: {
      value: _vm.taken.formSearch.wineIds,
      callback: function callback($$v) {
        _vm.$set(_vm.taken.formSearch, "wineIds", $$v);
      },
      expression: "taken.formSearch.wineIds"
    }
  }), _c(VAutocomplete, {
    attrs: {
      items: _vm.taken.filters.allowedStatus,
      "item-value": "id",
      "item-text": "name",
      label: "Status",
      "hide-details": "auto",
      multiple: "",
      clearable: ""
    },
    on: {
      blur: function blur($event) {
        _vm.taken.formSearch.allowedStatus != _vm.taken.lastSearch.allowedStatus && _vm.takenSearch();
      }
    },
    model: {
      value: _vm.taken.formSearch.allowedStatus,
      callback: function callback($$v) {
        _vm.$set(_vm.taken.formSearch, "allowedStatus", $$v);
      },
      expression: "taken.formSearch.allowedStatus"
    }
  })], 1)])]), _c("div", {
    staticClass: "mt-default"
  }, [_c("div", {
    staticClass: "container-centered"
  }, [_vm.taken.isSearchPending ? _c("div", {
    staticClass: "list-empty text-center text-italic"
  }, [_c("p", [_vm._v("Loading data ...")])]) : _vm.taken.results.totalCount === null ? _c("div", {
    staticClass: "list-empty text-center text-italic"
  }, [_vm._v(" Please do a search to display the results table ")]) : _vm.taken.results.totalCount === 0 ? _c("div", {
    staticClass: "list-empty text-center text-italic"
  }, [_vm._v(" No taken photo matchs these filters ")]) : _c(VDataTable, {
    staticClass: "cursor--pointer",
    attrs: {
      headers: _vm.taken.results.headers,
      items: _vm.taken.results.items,
      "items-per-page": +_vm.taken.results.totalCount,
      "footer-props": {
        options: {
          itemsPerPage: -1
        }
      }
    },
    on: {
      "click:row": _vm.takenRowClick
    },
    scopedSlots: _vm._u([{
      key: "item.creationDate",
      fn: function fn(_ref5) {
        var item = _ref5.item;
        return [_vm._v(" " + _vm._s(_vm._f("formatDate_string")(item.creationDate)) + " ")];
      }
    }, {
      key: "item.users",
      fn: function fn(_ref6) {
        var item = _ref6.item;
        return [_c("div", [_vm._v(_vm._s(item.targetedUser.fullName))]), item.creationUser.id !== item.targetedUser.id ? _c("div", {
          staticClass: "text-smaller text-italic"
        }, [_vm._v(" by " + _vm._s(item.creationUser.fullName) + " ")]) : _vm._e()];
      }
    }, {
      key: "item.contents",
      fn: function fn(_ref7) {
        var item = _ref7.item;
        return _vm._l(item.contents, function (content) {
          return _c("div", {
            key: "photo-content-" + content.id,
            staticClass: "mb-1 text-smaller"
          }, [_vm._v(" " + _vm._s(content.nbBottles + "b. of " + content.tastingPhotoRequired.wine.displayName + " - " + content.tastingPhotoRequired.wine.namingData.sku + ", from " + content.tastingPhotoRequired.fromReference.shorterReference()) + " ")]);
        });
      }
    }, {
      key: "item.status",
      fn: function fn(_ref8) {
        var item = _ref8.item;
        return [_c("div", [_c("svg", {
          staticClass: "icon icon-xxs dot mr-1",
          class: [_vm.takenGetStatusClass(item)],
          attrs: {
            xmlns: "http://www.w3.org/2000/svg",
            width: "512",
            height: "512",
            viewBox: "0 0 512 512"
          }
        }, [_c("circle", {
          attrs: {
            cx: "256",
            cy: "256",
            r: "256"
          }
        })]), _vm._v(" " + _vm._s(Object.values(_vm.TASTING_PHOTOS.TAKEN.STATUS).find(function (x) {
          return x.id === item.status;
        }).name) + " ")])];
      }
    }, {
      key: "item.actions",
      fn: function fn(_ref9) {
        var item = _ref9.item;
        return [_c("div", {
          staticClass: "td-without-link --inline-actions",
          on: {
            click: function click($event) {
              $event.stopPropagation();
            }
          }
        }, [_c("div", {
          staticClass: "table-actions"
        }, [_c("a", {
          attrs: {
            href: "#",
            disabled: item.isBusy
          },
          on: {
            click: function click($event) {
              return _vm.takenRowClick(item);
            }
          }
        }, [_vm._v(" Details ")])])])];
      }
    }], null, true)
  })], 1)])])]), _vm.taken.editedId > 0 ? _c("TastingPhotoFormModal", {
    ref: "tastingPhotoTakenForm",
    attrs: {
      id: _vm.taken.editedId,
      loggedUserData: _vm.loggedUserData
    },
    on: {
      entityUpdated: function entityUpdated($event) {
        {
          _vm.takenSearch();
          _vm.requiredSearch();
        }
      },
      closed: function closed($event) {
        _vm.taken.editedId = null;
      }
    }
  }) : _vm._e()], 1)], 1)], 1)]), _vm.upload.isComponentCreated ? _c("TastingPhotoUploadFormModal", {
    ref: "tastingPhotoUploadForm",
    attrs: {
      loggedUserData: _vm.loggedUserData,
      tastingPhotoRequiredId: _vm.upload.tastingPhotoRequiredId
    },
    on: {
      closed: function closed($event) {
        return _vm.closeUpload();
      }
    }
  }) : _vm._e(), _c("Confirm", {
    ref: "confirm"
  }), _c("ErrorModal", {
    ref: _vm.ERROR_DATA.ref
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };